import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

const COMPACT_ALGORITHM_STORAGE_KEY = 'compactAlgorithm';

interface CompactAlgorithmContextType {
  isCompactEnabled: boolean;
  setIsCompactEnabled: (enabled: boolean) => void;
}

const CompactAlgorithmContext = createContext<CompactAlgorithmContextType | undefined>(undefined);

interface CompactAlgorithmProviderProps {
  children: ReactNode;
}

export const CompactAlgorithmProvider: React.FC<CompactAlgorithmProviderProps> = ({ children }) => {
  const [isCompactEnabled, setIsCompactEnabledState] = useState<boolean>(() => {
    const stored = localStorage.getItem(COMPACT_ALGORITHM_STORAGE_KEY);
    if (stored !== null) {
      return stored === 'true';
    }
    // Default to true (enabled)
    return false;
  });

  const setIsCompactEnabled = (enabled: boolean) => {
    setIsCompactEnabledState(enabled);
    localStorage.setItem(COMPACT_ALGORITHM_STORAGE_KEY, String(enabled));
  };

  return (
    <CompactAlgorithmContext.Provider value={{ isCompactEnabled, setIsCompactEnabled }}>
      {children}
    </CompactAlgorithmContext.Provider>
  );
};

export const useCompactAlgorithm = (): CompactAlgorithmContextType => {
  const context = useContext(CompactAlgorithmContext);
  if (context === undefined) {
    throw new Error('useCompactAlgorithm must be used within a CompactAlgorithmProvider');
  }
  return context;
};

